import * as React from 'react';

function SvgShare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.231 17.233l5.88-5.18c.175-.176.175-.525 0-.7l-5.88-5.181c-.264-.264-.703 0-.703.353V9.07c-11.5 0-11.41 12.289-11.41 12.289s.788-7.022 11.41-7.022v2.545c0 .352.44.617.703.352z"
        fill="#414B56"
      />
      <path
        d="M15.5 4.48a.75.75 0 01.102 1.493l-.102.007H4.75v17.794h20.037l.001-7.21a.75.75 0 01.648-.744l.102-.007a.75.75 0 01.743.648l.007.102v7.961a.75.75 0 01-.648.743l-.102.007H4a.75.75 0 01-.743-.648l-.007-.102V5.23a.75.75 0 01.648-.743L4 4.48h11.5z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgShare;
